import { ITooltip } from 'react-tooltip';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { FunctionComponent } from 'preact';
import { TooltipContainer } from './Tooltip.styles';

export const Tooltip: FunctionComponent<ITooltip> = (props) => {
  const {
    tertiaryBox: { bgColor, mainFontColor },
  } = usePTPConfigContext();

  return (
    <TooltipContainer
      textColor={mainFontColor}
      backgroundColor={bgColor}
      place="top"
      clickable
      globalCloseEvents={{ escape: true }}
      {...props}
    />
  );
};
